function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "customer-service/email");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M430,215 C430,333.741105 333.741357,430 215.000563,430 C96.2586427,430 0,333.741105 0,215 C0,96.2588947 96.2586427,0 215.000563,0 C333.741357,0 430,96.2588947 430,215",
  id: "path-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M310.000563,525 C191.258643,525 95,428.741105 95,310 C95,191.258895 203.836922,40.8154049 276.199219,40.8154049 C438.785156,40.8154049 525,119.515698 525,310 C525,428.741105 428.741357,525 310.000563,525 Z",
  id: "path-3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.5125714,6.91952747 L0.402488529,308.091569 C-0.125977842,312.394528 2.93521254,316.264461 7.23340569,316.791115 L187.209479,338.816961 C191.515501,339.343615 195.422237,336.300725 195.950704,332.021172 L233.052958,30.8491307 C233.581424,26.5461714 230.524148,22.6723377 226.22204,22.1456836 L46.2537966,0.123738609 C45.9288877,0.0847271916 45.6039787,0.0613203413 45.2829843,0.0613203413 C41.3723332,0.0613203413 37.9979776,2.96376978 37.5125714,6.91952747 Z",
  id: "path-5"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "customer-service/email",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Delivery",
  transform: "translate(95.000000, 95.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Circle"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("use", {
  id: "Fill-1",
  fill: "#B9D5E0",
  xlinkHref: "#path-1"
}))), /*#__PURE__*/React.createElement("mask", {
  id: "mask-4",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-3"
})), /*#__PURE__*/React.createElement("g", {
  id: "Fill-1"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  mask: "url(#mask-4)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(309.373966, 314.001699) rotate(8.000000) translate(-309.373966, -314.001699) translate(127.873966, 63.501699)"
}, /*#__PURE__*/React.createElement("g", {
  id: "mobile",
  transform: "translate(181.543555, 250.504931) rotate(-7.000000) translate(-181.543555, -250.504931) translate(28.043555, 17.504931)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M47.8323623,27.4028007 L1.02513044,406.892253 C-1.08841628,424.023825 11.1310149,439.542373 28.305539,441.642422 L224.470072,465.615714 C241.675908,467.719659 257.2731,455.563529 259.382733,438.467023 L306.193879,58.9853624 C308.307425,41.8498941 296.087994,26.3313469 278.909556,24.2351937 L82.7528508,0.254109695 C81.453411,0.0982618707 80.1578851,0.0203379584 78.8819291,0.0203379584 C63.2573393,0.0203379584 49.785436,11.6076237 47.8323623,27.4028007 Z",
  id: "Clip-7",
  fill: "#2C3E50"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#182838",
  cx: 129.141715,
  cy: 408.439187,
  r: 19
}), /*#__PURE__*/React.createElement("g", {
  id: "Group-3",
  transform: "translate(39.654537, 42.278083)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-6",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-5"
})), /*#__PURE__*/React.createElement("use", {
  id: "Clip-10",
  fill: "#637A92",
  xlinkHref: "#path-5"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Box",
  transform: "translate(180.674443, 232.942326) rotate(-180.000000) translate(-180.674443, -232.942326) translate(105.674443, 170.442326)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(0.585938, 0.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.25277607e-13,70.2925725 L148.810897,70.2925725 L82.9560932,121.735297 C80.7174683,123.429343 78.8891852,124.970409 77.128302,124.970409 L71.8381516,124.970409 C70.0772684,124.970409 66.0103603,121.735297 66.0103603,121.735297 L6.25277607e-13,70.2925725 Z",
  id: "Fill-8",
  fill: "#C6B25D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M148.811059,70.4030968 L0.000162643155,70.4030968 L0.000162643155,12.5809062 C0.000162643155,10.7941959 1.4276274,9.34579439 3.18851062,9.34579439 L145.622711,9.34579439 C147.383594,9.34579439 148.811059,10.7941959 148.811059,12.5809062 L148.811059,70.4030968 Z",
  id: "Fill-6",
  fill: "#D7D7D7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.9907152,10.9527915 L136.184162,10.9527915 L136.184162,97.2479377 C136.184162,98.3525072 135.288732,99.2479377 134.184162,99.2479377 L15.9907152,99.2479377 C14.8861457,99.2479377 13.9907152,98.3525072 13.9907152,97.2479377 L13.9907152,10.9527915 L13.9907152,10.9527915 Z",
  id: "Rectangle-4",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M103.125,54.1673123 C103.125,66.8210887 96.1788741,75.6721759 76.2938862,75.6721759 C64.9213075,75.6721759 59.5414649,72.8529407 59.5414649,64.9853077 C59.5414649,51.5447679 64.4446126,45.840734 76.1576877,45.840734 C81.1970339,45.840734 85.691586,46.6274973 89.2327482,47.4142606 L86.9854722,67.8045429 C92.910109,66.1654527 95.7021792,61.3137456 95.7021792,54.1673123 C95.7021792,44.3983346 88.8922518,39.7433184 77.5877724,39.7433184 C62.6059322,39.7433184 54.2297215,49.7745505 54.2297215,66.6899615 C54.2297215,72.3004471 55.9377058,76.0316324 59.383235,78.3104166 C62.5007592,80.3722667 67.0407557,84.0644669 73.0251211,84.0644669 C77.996368,84.0644669 83.9891041,83.7366489 86.2363801,83.4743944 L86.2363801,87.6704654 C84.0572034,88.063847 78.0644673,88.7850467 73.0251211,88.7850467 C65.7279398,88.7850467 59.9336307,84.903815 55.672872,82.6767444 C49.8339417,79.6247737 46.875,74.3845284 46.875,66.6899615 C46.875,46.3652428 58.3837772,34.5637933 78.2687651,34.5637933 C92.8420097,34.5637933 103.125,41.1201542 103.125,54.1673123 Z M77.34375,52.1486433 C76.6601563,52.0871578 75.5664063,52.0871578 74.8144531,52.0871578 C71.1914063,52.0871578 69.140625,53.8087515 69.140625,63.4619733 C69.140625,67.0281317 70.78125,67.2740737 75.6347656,67.2740737 L77.34375,52.1486433 Z",
  id: "@",
  fill: "#2C3E50",
  fillRule: "nonzero",
  transform: "translate(75.000000, 61.674420) rotate(180.000000) translate(-75.000000, -61.674420) "
}), /*#__PURE__*/React.createElement("path", {
  d: "M148.811059,70.4030968 C141.541998,70.3185093 137.907468,70.2762155 137.907468,70.2762155 C134.961084,70.2762155 114.347831,59.0835162 76.0677083,36.6981175 C35.8859931,59.0835162 13.9699203,70.2762155 10.31949,70.2762155 C10.31949,70.2762155 6.87971422,70.3185093 0.000162643155,70.4030968 L0.000162643155,4.02352993 C0.000162643155,1.97239607 1.4276274,0.309638856 3.18851062,0.309638856 L145.622711,0.309638856 C147.383594,0.309638856 148.811059,1.97239607 148.811059,4.02352993 L148.811059,70.4030968 Z",
  id: "Fill-6",
  fill: "#E0CE80"
}), /*#__PURE__*/React.createElement("path", {
  d: "M70.4059728,43.8335098 C70.7373344,43.8335098 47.268731,30.5516246 0.000162643155,3.98785423 C0.000162643155,1.9564236 1.4276274,0.309638856 3.18851062,0.309638856 L145.622711,0.309638856 C147.383594,0.309638856 148.811059,1.9564236 148.811059,3.98785423 C117.954733,20.5812398 94.9471839,33.863125 79.7884115,43.8335098 C77.4982348,45.3398285 72.9930873,45.3398285 70.4059728,43.8335098 Z",
  id: "Fill-6",
  fill: "#C6B25D"
}))))));

var SvgEmail = function SvgEmail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "620px",
    height: "620px",
    viewBox: "0 0 620 620",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/email.d469447b.svg";
export { ForwardRef as ReactComponent };